module.exports = __webpack_public_path__ + "static/media/img1.85cb8baa.jpg";